export const setFoodcourt = (data) => ({
    type: 'SET_FOODCOURT',
    data
});